<div class="modal-body modal-scss">
  <div class="mb-2">
    @switch (mode) {
      @case ('warningMode') {
        <div>
          @for (m of messagesDisplayArray; track m) {
            <div>
              @if (m.refExpediteurRequired || m.RefExpediteurRequired) {
                <div class="alert alert-warning">
                  {{ 'error.noSenderReferenceEncoded' | translate }}
                </div>
              }
              @if (m.expediteurRequired || m.ExpediteurRequired) {
                <div class="alert alert-warning">{{ 'error.noSenderEncoded' | translate }}</div>
              }
              @if (m.objetRequired || m.ObjetRequired) {
                <div class="alert alert-warning">{{ 'error.noSubjectEncoded' | translate }}</div>
              }
              @if (m.remarquesRequired || m.RemarquesRequired) {
                <div class="alert alert-warning">{{ 'error.noRemarkEncoded' | translate }}</div>
              }
              @if (m.dateDocumentRequired || m.DateDocumentRequired) {
                <div class="alert alert-warning">
                  {{ 'error.noDocumentDateEncoded' | translate }}
                </div>
              }
              @if (m.dateEcheanceRequired || m.DateEcheanceRequired) {
                <div class="alert alert-warning">{{ 'error.noDueDateEncoded' | translate }}</div>
              }
              @if (m.codeClassementRequired || m.CodeClassementRequired) {
                <div class="alert alert-warning">
                  {{ 'error.noClassificationCodeSelected' | translate }}
                </div>
              }
              @if (m.dossierClassementRequired || m.DossierClassementRequired) {
                <div class="alert alert-warning">
                  {{ 'error.noClassificationCodeSelected' | translate }}
                </div>
              }
              @if (m.natureRequired || m.NatureRequired) {
                <div class="alert alert-warning">{{ 'error.noNatureSelected' | translate }}</div>
              }
              @if (m.sourceRequired || m.SourceRequired) {
                <div class="alert alert-warning">{{ 'error.noSourceSelected' | translate }}</div>
              }
              @if (m.refRecommandeRequired || m.RefRecommandeRequired) {
                <div class="alert alert-warning">
                  {{ 'error.noRecommendedReferenceEncoded' | translate }}
                </div>
              }
              @if (m.dateEntreeDocumentInvalide || m.DateEntreeDocumentInvalide) {
                <div class="alert alert-warning">
                  {{ 'error.invalidDocumentEntryDate' | translate }}
                </div>
              }
              @if (m.dateDocumentInvalide || m.DateDocumentInvalide) {
                <div class="alert alert-warning">{{ 'error.invalidDocumentDate' | translate }}</div>
              }
              @if (m.dateDocumentSuperieureDateEntree || m.DateDocumentSuperieureDateEntree) {
                <div class="alert alert-warning">
                  {{ 'error.documentDateGreaterThanEntryExitDate' | translate }}
                </div>
              }
              @if (m.dateDocumentErronee || m.DateDocumentErronee) {
                <div class="alert alert-warning">{{ 'error.documentDateInError' | translate }}</div>
              }
              @if (m.dateEcheanceInferieurOuEgaleDateEntree || m.DateEcheanceInferieurOuEgaleDateEntree) {
                <div class="alert alert-warning">
                  {{ 'error.dueDateLessThanOrEqualEntryExitDate' | translate }}
                </div>
              }
              @if (m.creationContactAvecTypeContactImpossible || m.CreationContactAvecTypeContactImpossible) {
                <div class="alert alert-warning">
                  {{ 'error.authorization.contactCreationNotAllowed' | translate }}
                </div>
              }
            </div>
          }
        </div>
      }
      @case ('errorsMode') {
        <div>
          @for (m of errors; track m) {
            <div>
              @if (m.refExpediteurRequired) {
                <div class="alert alert-danger">{{ 'error.noSenderReferenceEncoded' | translate }}</div>
              }
              @if (m?.field === '') {
                <div class="alert alert-danger">{{ m?.message }}</div>
              }
              @if (m?.field === 'Id') {
                <div class="alert alert-danger">{{ m?.message }}</div>
              }
              @if (m?.field === 'UtilisableParContactId') {
                <div class="alert alert-danger">
                  @if (m?.message === 'No Private Contact Selected.') {
                    <span> {{ 'error.noContactSelected' | translate }}</span>
                  }
                </div>
              }
              @if (m?.field === 'CocherAjouterDroitAccesGroupeID') {
                <div class="alert alert-danger">{{ 'error.noGroupSelected' | translate }}</div>
              }
              @if (m.expediteurRequired) {
                <div class="alert alert-danger">{{ 'error.noSenderEncoded' | translate }}</div>
              }
              @if (m.objetRequired) {
                <div class="alert alert-danger">{{ 'error.noSubjectEncoded' | translate }}</div>
              }
              @if (m.remarquesRequired) {
                <div class="alert alert-danger">{{ 'error.noRemarkEncoded' | translate }}</div>
              }
              @if (m.dateDocumentRequired) {
                <div class="alert alert-danger">{{ 'error.noDocumentDateEncoded' | translate }}</div>
              }
              @if (m.dateEcheanceRequired) {
                <div class="alert alert-danger">{{ 'error.noDueDateEncoded' | translate }}</div>
              }
              @if (m.codeClassementRequired) {
                <div class="alert alert-danger">{{ 'error.noClassificationCodeSelected' | translate }}</div>
              }
              @if (m.dossierClassementRequired) {
                <div class="alert alert-danger">{{ 'error.noClassificationCodeSelected' | translate }}</div>
              }
              @if (m.natureRequired) {
                <div class="alert alert-danger">{{ 'error.noNatureSelected' | translate }}</div>
              }
              @if (m.sourceRequired) {
                <div class="alert alert-danger">{{ 'error.noSourceSelected' | translate }}</div>
              }
              @if (m.refRecommandeRequired) {
                <div class="alert alert-danger">{{ 'error.noRecommendedReferenceEncoded' | translate }}</div>
              }
              @if (m.projetRequired) {
                <div class="alert alert-danger">{{ 'error.pleaseSelectProject' | translate }}</div>
              }
              @if (m.TVAInvalide) {
                <div class="alert alert-danger">{{ 'error.invalidVATNumber' | translate }}</div>
              }
              @if (m.CreationContactAvecTypeContactImpossible) {
                <div class="alert alert-danger">{{ 'error.contactCreationNotAllowed' | translate }}</div>
              }
              @if (m.AdresseImpressionCPLocaliteInvalide) {
                <div class="alert alert-danger">{{ 'error.invalidAddress' | translate }}</div>
              }
              @if (m?.field === 'parDefault') {
                <div class="alert alert-danger">{{ 'error.defaultFieldNotNull' | translate }}</div>
              }
              @if (m?.field === 'UserId') {
                <div class="alert alert-danger">{{ 'error.userFieldRequired' | translate }}</div>
              }
              @if (m?.field === 'ServiceId') {
                <div class="alert alert-danger">{{ 'error.serviceFieldRequired' | translate }}</div>
              }
              @if (m?.field === 'DestinatairesUsers') {
                <div class="alert alert-danger">{{ 'error.invalidRecipientList' | translate }}</div>
              }
              @if (m?.field === 'ServiceAccessRight.InterdireDocumentConfidentiel') {
                <div class="alert alert-danger">
                  {{ 'error.confidentialDocumentsOptionsError' | translate }}
                </div>
              }
              @if (m?.field === 'BacSourceId') {
                <div class="alert alert-danger">{{ 'error.emptyBacSourceParameter' | translate }}</div>
              }
              @if (m?.field === 'StartStepGuid') {
                <div class="alert alert-danger">{{ 'error.missingOrIncorrectGuid' | translate }}</div>
              }
              @if (m?.field === 'ModifyDataFieldsInput') {
                <div class="alert alert-danger">{{ 'error.incorrectField' | translate }}</div>
              }
              @if (m?.field === 'Conditions') {
                <div class="alert alert-danger">{{ 'error.errorInBacConditions' | translate }}</div>
              }
              @if (m?.field === 'SuppressionPrincipaleImpossible') {
                <div class="alert alert-danger">
                  {{ 'error.unableToDeletePrimaryAddress' | translate }}
                </div>
              }
              @if (m?.field === 'LinkMailId') {
                <div class="alert alert-danger">{{ 'error.chooseMailToLink' | translate }}</div>
              }
              @if (m?.field === 'PoliceFigee') {
                <div class="alert alert-danger">{{ 'error.fontSizeRequired' | translate }}</div>
              }
              @if (m?.message.includes('PersonalParams Name already used')) {
                <div class="alert alert-danger">
                  {{ 'error.duplicateDescriptionExists' | translate }}
                </div>
              }
              <!-- L'erreur backend n'est pas très précise mais il s'agit bien de l'ID du courrier qui n'a pas été trouvé. En effet, ici on veut juste créer un nouveau courrier en y joignant un lien vers un autre courrier. Le lien est un get global mais l'ID courrier est un simple input-->
              @if (m?.message.includes('The Lien field is invalid') && globalMessage.includes('This combinaison (courrierID, linkCourrierID)')) {
                <div class="alert alert-danger">
                  {{ 'error.linkCourrierIDNotFound' | translate }}
                </div>
              }
            </div>
          }
        </div>
      }
      @case ('accesDeniedMode') {
        <div>
          @for (er of accesDeniedErrors; track er) {
            <div>
              @if (er.unauthorizedMailCreationEntrant) {
                <div class="alert alert-danger">
                  {{ 'error.authorization.unableToCreateIncomingMailForService' | translate }}
                </div>
              }
              @if (er.unauthorizedMailCreationSortant) {
                <div class="alert alert-danger">
                  {{ 'error.authorization.unableToCreateOutgoingMailForService' | translate }}
                </div>
              }
              @if (er.unauthorizedMailCreationInterne) {
                <div class="alert alert-danger">
                  {{ 'error.authorization.unableToCreateInternalMailForService' | translate }}
                </div>
              }
              @if (er.unauthorizedService) {
                <div class="alert alert-danger">{{ 'error.authorization.unableToCreateRecordForService' | translate }}</div>
              }
              @if (er.unauthorizedMailModification) {
                <div class="alert alert-danger">
                  {{ 'error.authorization.unableToModifyMailForService' | translate }}
                </div>
              }
              @if (er.CreationContactAvecTypeContactImpossible) {
                <div class="alert alert-danger">
                  {{ 'error.authorization.contactCreationNotAllowedType' | translate }}
                </div>
              }
            </div>
          }
        </div>
      }
      @default {
        <div></div>
      }
    }
  </div>
  <i-button styleClass="bottomButton red mb-3" (click)="ref.close()" [text]="'cancel' | translate"></i-button>
</div>
